<app-loader [hidden]="!loaderService.isLoading"></app-loader>

<noscript
  ><iframe
    [src]="dataLayerNoScriptSafeUrl"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe
></noscript>

<ng-template cxOutletRef="cx-header">
  <header *ngIf="headerAndFooterService.showHeader">
    <app-header></app-header>
    <div
      class="header-placeholder"
      [ngClass]="{ 'no-banner-header-placeholder': !appService.hasBanner }"
    ></div>
  </header>
  <header *ngIf="headerAndFooterService.showCheckoutHeader">
    <app-checkout-header></app-checkout-header>
  </header>
</ng-template>

<!-- Remove 'SiteLogin' and 'PreHeader' slots from all pages -->
<ng-template cxOutletRef="SiteLogin"></ng-template>
<ng-template cxOutletRef="PreHeader"></ng-template>

<cx-storefront></cx-storefront>

<ng-template cxOutletRef="cx-footer">
  @defer {
    <app-footer *ngIf="headerAndFooterService.showFooter"></app-footer>
    <app-checkout-footer *ngIf="headerAndFooterService.showCheckoutFooter"></app-checkout-footer>
  }
</ng-template>

<div class="up-button" *ngIf="upButtonDisplayed" (click)="scrollToTop()">
  <app-svg iconName="chevron-up" dimension="2rem"></app-svg>
</div>
@defer {
  <app-notification></app-notification>
}

<app-add-to-cart-popup></app-add-to-cart-popup>
